import { createRouter, createWebHistory } from 'vue-router'
import PayoutsPage from '@/views/PayoutsPage.vue'
import AdvancesPage from '@/views/AdvancesPage.vue'

const routes = [
  {
    path: '/',
    name: 'payouts',
    component: PayoutsPage,
  },
  {
    path: '/advances',
    name: 'advances',
    component: AdvancesPage,
  },
]

export default createRouter({
  history: createWebHistory('/payouts'),
  linkActiveClass: 'active',
  linkExactActiveClass: '',
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})
